import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ReportModel } from 'src/app/Models/report-model';
import { CodeReviewService } from 'src/app/Services/code-review.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { ProjectService } from 'src/app/Services/project.service';
import { SharedService } from 'src/app/Services/shared.service';

@Component({
  selector: 'ze-code-review-report',
  templateUrl: './code-review-report.component.html',
  styleUrls: ['./code-review-report.component.scss']
})
export class CodeReviewReportComponent implements OnInit {

  reportUpdateForm: FormGroup;
  reviewId: string = null;
  projectId: string;
  reportArtifactNameOptions = [];
  allReportsData = [];
  artifactReports = [];
  dialogRef;
  currentReport: ReportModel;

  constructor(private route: ActivatedRoute,
    private codeReviewService: CodeReviewService,
    private notifyService: NotifyService,
    private projectService: ProjectService,
    private sharedService: SharedService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,) { }

  ngOnInit() {
    this.route.parent.params.subscribe(params => {
      this.reviewId = params['reviewId'];
      this.projectId = localStorage.getItem("projectId");
    });
  }

  onChangeReport(dialogTemplate: TemplateRef<any>, report: any) {
    this.currentReport = report;
    this.sharedService.loaderHide.emit(true);
    this.reportUpdateForm = this.buildForm();
    this.getReportsData(true, dialogTemplate);
  }

  buildForm(): FormGroup {    
    const reportForm: FormGroup = this.formBuilder.group({ 
      reportArtifact: new FormControl("", Validators.required),
      report: new FormControl("", Validators.required),
    })
    return reportForm;
  }

  openChangeReportDialog(dialogTemplate: TemplateRef<any>) {
    this.dialogRef = this.dialog.open(dialogTemplate, {
      width: '30%',
      // height: '63%',
      disableClose: true,
      backdropClass: 'overlay-backdrop-dark-class',
    });

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sharedService.loaderHide.emit(false);
        location.reload();
      }
    });
  }

  getReportsData(openChangeReportDialog: boolean, dialogTemplate: TemplateRef<any>) {
    this.projectService.getCodeReviewReportsDataByProjectId(this.projectId).subscribe(data => {
      if(data["operationStatus"] != "ERROR") {
        this.reportArtifactNameOptions = data["data"]["artifacts"];
        this.allReportsData = data["data"]["reports"];
        if (this.reportArtifactNameOptions.length > 0) {
          let suiteId = this.currentReport.suite_id["$oid"] ? this.currentReport.suite_id["$oid"] : this.currentReport.suite_id;
          let reportArtifactIndex = this.reportArtifactNameOptions.findIndex(reportArtifactOption => reportArtifactOption.artifactId == suiteId);
          if (reportArtifactIndex != -1) {
            this.reportUpdateForm.controls.reportArtifact.setValue(this.reportArtifactNameOptions[reportArtifactIndex]);
          } else {
            this.reportUpdateForm.controls.reportArtifact.setValue(this.reportArtifactNameOptions[0]);
          }      
          this.artifactReports = this.allReportsData.filter(artifactReport => artifactReport.artifactId == this.reportUpdateForm.controls.reportArtifact.value.artifactId);
          if (this.artifactReports.length > 0) {
            let reportIndex = this.artifactReports.findIndex(artifactReport => artifactReport.reportId == this.currentReport._id);
            if (reportIndex != -1) {
              this.reportUpdateForm.controls.report.setValue(this.artifactReports[reportIndex]);
            } else {
              this.reportUpdateForm.controls.report.setValue(this.artifactReports[0]);
            } 
          }
        }
        if (openChangeReportDialog) {
          this.openChangeReportDialog(dialogTemplate);
        }
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.sharedService.loaderHide.emit(false);
    });
  }

  onSubmitChange() {
    this.sharedService.loaderHide.emit(true);
    this.codeReviewService.setCodeReviewReportByCodeReviewId(this.reportUpdateForm.controls.report.value.reportId, this.reviewId).subscribe(data=> {
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', 'Error in setting as CodeReview report');
        this.sharedService.loaderHide.emit(false);
      } else {
        this.notifyService.notify('success', 'Success', 'Successfully set as CodeReview report');
        this.dialogRef.close("Successfully set as CodeReview report");
      }
    }, error => {
      this.sharedService.loaderHide.emit(false);
    })
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onReportArtifactChange(value) { 
    this.reportUpdateForm.controls.report.setValue(null);
    this.artifactReports = this.allReportsData.filter(artifactReport => artifactReport.artifactId == value.artifactId);
    if (this.artifactReports.length > 0) {
      this.reportUpdateForm.controls.report.setValue(this.artifactReports[0]);
    }
  }

}
